import { Box } from '@mui/material';
import React from 'react';

import { Types } from '../../../Utils/Types/Posts';
import Posts from '../../PostList/Posts';

function DuplicatedPostList({ post }: any) {
  return (
    <Box sx={{ mt: 5 }}>
      <Posts
        postsTypes={[Types.IDEA]}
        analyticsTitle="Duplicated Ideas"
        trackingProps={{ category: 'Post', name: 'Click on Duplicated Ideas' }}
        limit={5}
        hideButtons
        queryOptions={{
          originalPostId: post.id,
        }}
        titleI18nKey="DUPLICATED_POSTS.TITLE"
        titleProps={{
          variant: 'h6',
          component: 'h3',
        }}
        disablePadding
        post={post}
        hideParentLink
      />
    </Box>
  );
}

export default DuplicatedPostList;
